import React from 'react';
import componentStyles from './insightBox.module.css';

const InsightBox = ({ betRecommendation}) => {
    // Extract insight data from bet recommendation
    const keyInsightHeadline = betRecommendation?.keyInsightHeadline || 'Key Insight';
    const featuredProp = betRecommendation?.featuredProp || {};
    const matchupAdvantage = betRecommendation?.matchupAdvantage || 'N/A';
    const lineMovementSummary = betRecommendation?.lineMovementSummary || 'N/A';
    const expertPickStatus = betRecommendation?.expertPickStatus || false;
    const weatherInfo = betRecommendation?.weatherImpact || null;

    // Get confidence grade color
    const getConfidenceGradeColor = (grade) => {
        switch (grade?.toUpperCase()) {
            case 'A+':
            case 'A':
                return '#00ff00'; // Green
            case 'B':
                return '#aaff00'; // Light green
            case 'C':
                return '#ffaa00'; // Orange
            default:
                return '#aaff00'; // Default to light green
        }
    };

    // Format featured prop display
    const formatFeaturedProp = () => {
        if (!featuredProp || typeof featuredProp === 'string') {
            return featuredProp || 'N/A';
        }
        
        // Handle featured prop object with propBet and propBetExplanation
        const { propBet, propBetExplanation } = featuredProp;
        
        if (propBet) {
            return (
                <div className={componentStyles.featuredPropContent}>
                    <div className={componentStyles.featuredPropBet}>
                        {propBet}
                    </div>
                    {propBetExplanation && (
                        <div className={componentStyles.featuredPropExplanation}>
                            {propBetExplanation}
                        </div>
                    )}
                </div>
            );
        }
        
        return 'N/A';
    };

    return (
        <div className={componentStyles.insightsContainer}>
            <h3 className={componentStyles.insightsTitle}>KEY INSIGHTS</h3>
            
            <div className={componentStyles.insightsGrid}>
                {/* Key Insight Headline */}
                <div className={componentStyles.insightBox}>
                    <div className={componentStyles.insightHeader}>
                        <span className={componentStyles.insightLabel}>HEADLINE</span>
                    </div>
                    <div className={componentStyles.insightContent}>
                        {keyInsightHeadline}
                    </div>
                </div>

                {/* Featured Prop */}
                <div className={componentStyles.insightBox}>
                    <div className={componentStyles.insightHeader}>
                        <span className={componentStyles.insightLabel}>FEATURED PROP</span>
                    </div>
                    <div className={componentStyles.insightContent}>
                        {formatFeaturedProp()}
                    </div>
                </div>

                {/* Matchup Advantage */}
                <div className={componentStyles.insightBox}>
                    <div className={componentStyles.insightHeader}>
                        <span className={componentStyles.insightLabel}>MATCHUP ADVANTAGE</span>
                    </div>
                    <div className={componentStyles.insightContent}>
                        {matchupAdvantage}
                    </div>
                </div>

                {/* Line Movement Summary */}
                <div className={componentStyles.insightBox}>
                    <div className={componentStyles.insightHeader}>
                        <span className={componentStyles.insightLabel}>LINE MOVEMENT</span>
                    </div>
                    <div className={componentStyles.insightContent}>
                        {lineMovementSummary}
                    </div>
                </div>
                {weatherInfo && (
                    <div className={componentStyles.insightBox}>
                        <div className={componentStyles.insightHeader}>
                            <span className={componentStyles.insightLabel}>WEATHER</span>
                        </div>
                        <div className={componentStyles.insightContent}>
                            {weatherInfo}
                        </div>
                    </div>
                )}

                {/* Expert Pick Status */}
                {/* {expertPickStatus && (
                    <div className={componentStyles.insightBox}>
                        <div className={componentStyles.insightHeader}>
                            <span className={componentStyles.insightLabel}>EXPERT PICK</span>
                        </div>
                        <div className={componentStyles.expertPickBadge}>
                            EXPERT BACKED
                        </div>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default InsightBox; 